import { API_ROOT_URL } from "../config";
import { handleResponse } from "../helpers";

export const noteService = {
  getNotes,
  viewNote,
  deleteNote
};

function getNotes() {
  const token = JSON.parse(localStorage.getItem("token"));
  const user = JSON.parse(localStorage.getItem("user"));
  const user_id = user.user_id;

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + token
    }
  };

  return fetch(
    `${API_ROOT_URL}/appointments/notes/?q=${user_id}`,
    requestOptions
  )
    .then(handleResponse)
    .then(userNote => {
      return userNote;
    });
}

function viewNote(note_id) {
  const token = JSON.parse(localStorage.getItem("token"));

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + token
    }
  };

  return fetch(
    `${API_ROOT_URL}/appointments/notes/${note_id}/`,
    requestOptions
  )
    .then(handleResponse)
    .then(userNote => {
      return userNote;
    });
}

function deleteNote(note_id) {
  const token = JSON.parse(localStorage.getItem("token"));

  const requestOptions = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + token
    }
  };

  return fetch(
    `${API_ROOT_URL}/appointments/notes/${note_id}/`,
    requestOptions
  )
    .then(handleResponse)
    .then(userNote => {
      return userNote;
    });
}


// WEBPACK FOOTER //
// ./src/services/note.service.js